import Vue from 'vue'

let uid = 0

export default new Vue({
  data() {
    return {
      supported: false,
      responses: {},
      listener: null,
    }
  },
  methods: {
    invoke(message, callback) {
      const id = ++uid
      this.responses[id] = callback

      this.send_message('invoke', {
        id,
        message,
      })
    },
    send_message(event, payload) {
      window.postMessage({
        source: 'lemonapt-app',
        payload: Object.assign({ event }, payload),
      }, '*')
    },
  },
  created() {
    this.listener = window.addEventListener('message', (e) => {
      // only accept messages from ext
      if (e.source !== window || e.data.source !== 'lemonapt-native-ext')
        return

      const data = e.data.payload
      const event = data.event

      if (event === 'ready')
        this.supported = true
      else if (event === 'response') {
        const id = data.id
        const response = data.response
        if (id && this.responses[id] && typeof (this.responses[id]) === 'function') {
          this.responses[id](response)
          this.$delete(this.responses, id)
        }
      }
    }, false)
  },
})



// WEBPACK FOOTER //
// ./client/src/native.js